import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { Button } from './ui/button';
import { MessageCircle } from 'lucide-react';
import { faqData } from '../data/mockData';
import { useFormModal } from './FormModalContext';

export const FAQ = () => {
  const { openForm } = useFormModal();
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-pink-50">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          {/* Title */}
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Perguntas Frequentes
            </h2>
            <div className="w-20 h-1 bg-gradient-to-r from-[#eb068c] to-[#c7056f] mx-auto rounded-full mt-6"></div>
          </div>

          {/* FAQ Accordion */}
          <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 border border-pink-100">
            <Accordion type="single" collapsible className="w-full">
              {faqData.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`}>
                  <AccordionTrigger className="text-left text-lg font-semibold text-gray-900 hover:text-[#eb068c]">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>

          {/* Contact CTA */}
          <div className="mt-12 text-center bg-white rounded-2xl p-6 md:p-8 shadow-md border border-pink-100 mx-4 md:mx-0">
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              Seu próximo presente pode ser inesquecível.
            </h3>
            <p className="text-gray-600 mb-6">
              Conte para nós o seu objetivo e vamos desenvolver a melhor solução para a sua empresa.
            </p>
            <Button 
              size="lg"
              onClick={openForm}
              className="bg-[#20BA5A] hover:bg-[#178C41] text-white px-6 md:px-8 py-4 md:py-6 text-base md:text-lg rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 w-full md:w-auto"
            >
              <MessageCircle className="mr-2 h-5 w-5" />
              Solicitar Orçamento
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
